export interface JobCardClassNames {
  wrapper: string;
  card: string;
}

export const CLASS_NAMES: JobCardClassNames = {
  wrapper: 'border-b border-solid border-neutral-200 last:border-0',
  card: 'px-4 py-3 flex flex-col gap-y-2',
};
